import type { ApolloClient } from '@apollo/client'
import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import { SubcategoryFilterDataDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { createAsyncFilterWithQuery } from './createAsyncFilterWithQuery'

export const createSubcategoryAsyncFilter = (
  apolloClient: ApolloClient<unknown>,
  companyId: string
): FilterDefinition =>
  createAsyncFilterWithQuery({
    label: i18n.t('expenses_v2.forms.fields.subcategory.label'),
    apolloClient,
    query: SubcategoryFilterDataDocument,
    variables: { companyIds: [companyId] },
    mapData: (data) => {
      const subcategories = data?.finance?.subcategories.nodes || []
      return subcategories.map((subcat) => ({
        label: subcat.label,
        value: subcat.identifier,
      }))
    },
  })
